var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFiRrCalculator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18,24H6a5.006,5.006,0,0,1-5-5V5A5.006,5.006,0,0,1,6,0H18a5.006,5.006,0,0,1,5,5V19A5.006,5.006,0,0,1,18,24ZM6,2A3,3,0,0,0,3,5V19a3,3,0,0,0,3,3H18a3,3,0,0,0,3-3V5a3,3,0,0,0-3-3Zm10,8H8A3,3,0,0,1,8,4h8a3,3,0,0,1,0,6ZM8,6A1,1,0,0,0,8,8h8a1,1,0,0,0,0-2ZM6,13a1,1,0,1,0,1,1A1,1,0,0,0,6,13Zm4,0a1,1,0,1,0,1,1A1,1,0,0,0,10,13Zm4,0a1,1,0,1,0,1,1A1,1,0,0,0,14,13ZM6,17a1,1,0,1,0,1,1A1,1,0,0,0,6,17Zm4,0a1,1,0,1,0,1,1A1,1,0,0,0,10,17Zm8-4a1,1,0,1,0,1,1A1,1,0,0,0,18,13Zm1,5a1,1,0,0,0-1-1H14a1,1,0,0,0,0,2h4A1,1,0,0,0,19,18Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrCalculator);
export default __webpack_public_path__ + "static/media/fi-rr-calculator.c3831c34.svg";
export { ForwardRef as ReactComponent };